import * as yup from 'yup';
import { useExperiment } from '@web/experiments';
import { schema as heroSchema } from '../../cms/builders/hero';
import { schema as pollSchema } from '../../cms/builders/confirmation_poll';
import { schema as bannerSchema } from '../../cms/builders/confirmation_banner';
import { schema as getSocialSchema } from '../../cms/builders/get_social_component';

export const freeItemsSchema = yup
  .object({
    component: yup.string().required(),
    items: yup.array(
      yup
        .object({
          label: yup.string(),
          quantity: yup.string().nullable(),
        })
        .transform(value => ({
          label: value.label,
          quantity: value.quantity || null,
        })),
    ),
  })
  .transform(value => ({
    component: value.component,
    items: value.items,
  }));

export const confirmationSchema = yup
  .object({
    hero: heroSchema,
    orderSummaryTitle: yup.string().required(),
    leftSideComponents: yup.array(
      yup.lazy(item => {
        switch (item.component) {
          case 'confirmation_poll':
            return pollSchema.required();
          default:
            return bannerSchema.required();
        }
      }),
    ),
    rightSideComponents: yup.array(
      yup.lazy(item => {
        switch (item.component) {
          case 'get_social_component':
            return getSocialSchema.required();
          default:
            return freeItemsSchema;
        }
      }),
    ),
    frequencyCalloutsList: yup.array(
      yup.object({
        heading: yup.string().nullable(),
        body: yup.string().required(),
      }),
    ),
  })
  .transform(value => {
    const freeItems = value.right_side_components?.find(
      item => item.component === 'free_items',
    );
    let { value: experimentValue } = useExperiment(
      freeItems?.items[0]?.test_name ?? null,
    );
    experimentValue = experimentValue || 'control';
    let freeItemsList = freeItems.items;
    if (freeItemsList?.[0]?.component === 'flagship_ab_test') {
      const experimentVariation = freeItemsList[0].variants.find(
        variant => variant.variant_name === experimentValue,
      );
      freeItemsList = experimentVariation?.blocks ?? [];
    }

    const experimentalRightSideComponents = value.right_side_components?.map(
      item =>
        item.component === 'free_items'
          ? { ...item, items: freeItemsList }
          : item,
    );

    return {
      hero: value.hero[0],
      leftSideComponents: value.left_side_components,
      rightSideComponents:
        experimentalRightSideComponents || value.right_side_components,
      frequencyCalloutsList: value.frequency_callouts_list,
      orderSummaryTitle: 'Order Summary',
    };
  });
